const PrivacyContactSectionKr = () => (
  <section className="prose mb-8">
    <h2 className="mb-4 text-xl font-bold">개인정보관리책임자 및 담당자</h2>
    <span>
      신선한여울은 회원의 개인정보보호를 가장 중요시하며, 회원의 개인정보가 훼손, 침해 또는 누설되지
      않도록 최선을 다하고 있습니다.
    </span>
    <h4>[개인정보관리책임자]</h4>
    <span>
      신선한여울 담당자 전자우편 : <span className="font-semibold">support@theplato.io</span>
    </span>
    <p className="prose whitespace-pre-wrap">
      {`기타 개인정보에 관한 상담이 필요한 경우에는 정보통신부 산하 공공기관인 한국인터넷진흥원(KISA) 개인정보침해신고센터 또는 경찰청 사이버테러대응센터로 문의하시기 바랍니다.
       
[한국인터넷진흥원 개인정보침해신고센터] 
1. 전화번호 : 국번없이 118
- 홈페이지 주소 : http://privacy.kisa.or.kr [경찰청 사이버테러대응센터] 
2. 전화번호 :02-393-9112 
- 홈페이지 주소 : http://www.netan.go.kr [대검찰청 사이버범죄수사단]
3. 전화번호 : 02-3480-3751 
- 홈페이지 주소 : http://www.spo.go.kr`}
    </p>
  </section>
)

export default PrivacyContactSectionKr
